import React, { FC } from 'react';
import classNames from 'classnames';
import { Link } from 'react-router-dom';
import { Avatar } from 'components/Avatar';

import './EmployeeCard.styles.scss';

type EmployeeCardProps = {
  className?: string;
  employeeId?: string;
  imageUrl?: string;
  firstName: string;
  lastName: string;
  isDeleted: boolean;
};

const EmployeeCard: FC<EmployeeCardProps> = (props) => {
  const { className, employeeId, imageUrl, firstName, lastName, isDeleted } = props;
  const classes = classNames(
    'nce-employee-card',
    className,
    isDeleted && 'nce-employee-card--deleted-user',
  );

  return (
    <Link to={`/employees/manage-employees/${employeeId}`} className={classes}>
      <div className='nce-employee-card__image'>
        <Avatar
          imageUrl={imageUrl || 'images/userDefault.png'}
          alt={`${firstName} ${lastName}`}
          size='md'
        />
      </div>
      <div className='nce-employee-card__info'>
        <p className='nce-employee-card__firstName'>{firstName}</p>
        <p className='nce-employee-card__lastName'>{lastName}</p>
      </div>
    </Link>
  );
};

export default EmployeeCard;
